import React from "react";
import { Col, Row } from "react-bootstrap";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { NFDateInput } from "../../../Shared/NewForms/NFDateInput";
import { useTranslation } from "react-i18next";

const VehicleDetailMain = () => {
  const {t} = useTranslation()
  return (
    <>
      <Row>
        <Col sm={6}>
          <NFTextInput title={t("Name")} fieldName={"name"} />
        </Col>
        <Col sm={6}>
          <NFTextInput title={t("Unique code")} fieldName={"uniqueCode"} />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFDateInput fieldName={"createDate"} title={t("Created Date")} />
        </Col>
        <Col sm={6}>
          <NFTextInput fieldName={"vehiclePlateNumber"} title={t("Vehicle Plate Number")} />
        </Col>
      </Row>
    </>
  );
};

export default VehicleDetailMain;
